var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 1.5C22.1297 1.5 22.4435 1.78215 22.4932 2.14823L22.5 2.25V18.75C22.5 20.7543 20.9276 22.3913 18.9492 22.4948L18.75 22.5H6C3.51472 22.5 1.5 20.4853 1.5 18C1.5 17.6203 1.78215 17.3065 2.14823 17.2568L2.25 17.25H3.75V2.25C3.75 1.8703 4.03215 1.55651 4.39823 1.50685L4.5 1.5H21.75ZM15 18.75H3.096L3.12263 18.8517C3.47374 20.0397 4.54055 20.9206 5.82373 20.9949L6 21L15.7506 21.0012C15.3265 20.437 15.0578 19.7491 15.0083 19.0014L15 18.75ZM21 3H5.25V17.249L15.75 17.25C16.0952 17.25 16.3859 17.4832 16.4732 17.8006L16.4932 17.8982L16.5 18V18.75C16.5 19.9926 17.5074 21 18.75 21C19.9409 21 20.9156 20.0748 20.9948 18.904L21 18.75V3ZM17.25 12C17.6642 12 18 12.3358 18 12.75C18 13.1297 17.7178 13.4435 17.3518 13.4932L17.25 13.5H7.52629C7.11207 13.5 6.77629 13.1642 6.77629 12.75C6.77629 12.3703 7.05844 12.0565 7.42452 12.0068L7.52629 12H17.25ZM14.25 9C14.6642 9 15 9.33579 15 9.75C15 10.1297 14.7178 10.4435 14.3518 10.4932L14.25 10.5H7.52629C7.11207 10.5 6.77629 10.1642 6.77629 9.75C6.77629 9.3703 7.05844 9.05651 7.42452 9.00685L7.52629 9H14.25ZM11.25 6C11.6642 6 12 6.33579 12 6.75C12 7.1297 11.7178 7.44349 11.3518 7.49315L11.25 7.5H7.52629C7.11207 7.5 6.77629 7.16421 6.77629 6.75C6.77629 6.3703 7.05844 6.05651 7.42452 6.00685L7.52629 6H11.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/Article.1e28aad096618b6c49195e9c17d77607.svg";
export { ForwardRef as ReactComponent };